import { Button, DatePicker, Form, Input, Modal, Row, Select, Table, Col, message } from 'antd'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import Filter from '../../../components/Filter'
import UploadProfilePicture from '../../../components/UploadProfilePicture'

function Diseases() {
    const [form] = Form.useForm()
    const API_URL = import.meta.env.VITE_API_URL
    const accessToken = useSelector((state) => state.user.accessToken)
    const [Diseases, setDiseases] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [currentDiseases, setCurrentDiseases] = useState(null)
    const [loading, setLoading] = useState(false)
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 })
    const [selectedFilters, setSelectedFilters] = useState({ search: null });
    const [filterOptions, setFilterOptions] = useState([]);
    const [photo, setPhoto] = useState("");
    useEffect(() => {
        fetchDiseases()
    }, [])

    useEffect(() => {
        if (isModalVisible && currentDiseases) {
            form.setFieldsValue({
                name: currentDiseases.name,
                name_ar: currentDiseases.name_ar,
                description: currentDiseases.description,
                description_ar: currentDiseases.description_ar,
                treatment: currentDiseases.treatment,
                treatment_ar: currentDiseases.treatment_ar,
            });
        }
    }, [isModalVisible, currentDiseases, form]);

    const fetchDiseases = async (page = 1, pageSize = 10, search = null) => {
        setLoading(true)
        try {
            const params = {
                limit: pageSize,
                page: page,
                ...(search && { search })
            }

            const response = await axios.get(`${API_URL}Diseases/get-diseases`, {
                params,
                headers: { Authorization: `Bearer ${accessToken}` }
            })
            setDiseases(response.data.Diseases)
            setPagination({
                current: page,
                pageSize: pageSize,
                total: response.data.totalCount
            })
        } catch (error) {
            console.error("Error fetching Diseases:", error)
            message.error("Failed to fetch Diseases")
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${API_URL}Diseases?id=${id}`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            })
            message.success("Diseases deleted successfully")
            fetchDiseases()
        } catch (error) {
            console.error("Error deleting Diseases:", error)
            message.error("Failed to delete Diseases")
        }
    }


    const handleSave = async (values) => {
        let payload = {};
        let hasImageChange = false;

        if (currentDiseases) {
            if (values.name !== currentDiseases.name) payload.name = values.name;
            if (values.name_ar !== currentDiseases.name_ar) payload.name_ar = values.name_ar;
            if (values.description !== currentDiseases.description) payload.description = values.description;
            if (values.description_ar !== currentDiseases.description_ar) payload.description_ar = values.description_ar;
            if (values.treatment !== currentDiseases.treatment) payload.treatment = values.treatment;
            if (values.treatment_ar !== currentDiseases.treatment_ar) payload.treatment_ar = values.treatment_ar;

            if (photo !== "" && photo !== currentDiseases.image) {
                payload.image = photo;
                hasImageChange = true;
            }


            if (Object.keys(payload).length === 0 && !hasImageChange) {
                message.info("No changes detected.");
                return;
            }
        } else {
            if (photo) {
                payload = {
                    name: values.name,
                    name_ar: values.name_ar,
                    description: values.description,
                    description_ar: values.description_ar,
                    treatment: values.treatment,
                    treatment_ar: values.treatment_ar,
                    ...(photo && { image: photo })
                };
            } else {
                message.error("Add Photo Diseases")
                return;
            }

        }

        try {
            if (currentDiseases) {
                await axios.patch(`${API_URL}Diseases?id=${currentDiseases.id}`, payload, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                message.success("Disease updated successfully");
            } else {
                await axios.post(`${API_URL}Diseases`, payload, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                message.success("Disease created successfully");
            }

            setIsModalVisible(false);
            form.resetFields();
            setPhoto("");
            fetchDiseases();
        } catch (error) {
            console.error("Error saving disease:", error);
            message.error(`Failed to ${currentDiseases ? 'update' : 'create'} disease`);
        }
    };



    const handleFilterChange = (key, value) => {
        let updatedFilters = { ...selectedFilters };
        let errorMessageShown = false;


        if (key === "search") {
            let search = null;

            if (value && value.trim().length > 0) {
                if (value.length > 2) {
                    search = value.trim(); // Keep the search term as a string
                }
            }

            updatedFilters.search = search;
        }

        if (key === "") {
            fetchDiseases();
            updatedFilters = {};
        }

        setSelectedFilters(updatedFilters);

        fetchDiseases(1, pagination.pageSize, updatedFilters.search);
    };


    const columns = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        {
            title: 'View',
            render: (_, record) => (
                <Button onClick={() => {
                    setCurrentDiseases(record)
                    setIsModalVisible(true)
                }}>
                    View
                </Button>
            )
        },
        {
            title: 'Delete',
            render: (_, record) => (
                <Button style={{ borderRadius: 0, borderColor: "#FF4D4F", backgroundColor: "#FF4D4F", color: "#FFFFFF" }}
                    danger onClick={() => handleDelete(record.id)}>
                    Delete
                </Button>
            )
        }
    ]
    useEffect(() => {
        fetchDiseases(1, pagination.pageSize, selectedFilters.search);
    }, [pagination.pageSize, selectedFilters]);
    return (
        <div className="space-y-5">
            <Filter
                filterOptions={filterOptions}
                addItemName="Add Diseases"
                resetFilter={false}
                filterBy={false}
                setFilterOptions={setFilterOptions}
                addItemAction={() => {
                    setCurrentDiseases(null);
                    setIsModalVisible(true);
                }}
                onFilterChange={handleFilterChange}
                searchBarPlaceholder="Search Diseases"
            />

            <div className="table-responsive-wrapper responsive-table-container">
                <Table
                    className="customTable"
                    columns={columns}
                    dataSource={Diseases}
                    loading={loading}
                    rowKey="id"
                    pagination={pagination}
                    onChange={(pagination) => fetchOffers(pagination.current, pagination.pageSize)}
                />
            </div>

            <Modal
                title={currentDiseases ? "View Diseases" : "Add Diseases"}
                visible={isModalVisible}
                onCancel={() => {
                    setIsModalVisible(false);
                    setCurrentDiseases(null);
                    form.resetFields("");
                    setPhoto("");
                }}
                footer={null}
                width={800}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSave}
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <UploadProfilePicture
                                    value={photo || (currentDiseases ? currentDiseases.image : "")}
                                    onChange={(url) => setPhoto(url)}
                                />

                            </div>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Name (EN)"
                                name="name"
                                rules={[{ required: true, message: "Please enter name" }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Name (AR)"
                                name="name_ar"
                                rules={[{ required: true, message: "Please enter name" }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="Description (EN)"
                                name="description"
                                rules={[{ required: true, message: "Please enter description" }]}
                            >
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Description (AR)"
                                name="description_ar"
                                rules={[{ required: true, message: "Please enter description" }]}
                            >
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="Treatment (EN)"
                                name="treatment"
                                rules={[{ required: true, message: "Please enter treatment" }]}
                            >
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Treatment (AR)"
                                name="treatment_ar"
                                rules={[{ required: true, message: "Please enter treatment" }]}
                            >
                                <Input.TextArea rows={4} />
                            </Form.Item>
                        </Col>
                    </Row>


                    <div className="flex justify-end gap-4">
                        <Button onClick={() => setIsModalVisible(false)}>Cancel</Button>
                        <Button type="primary" htmlType="submit">
                            {currentDiseases ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </Form>
            </Modal>
        </div>

    )
}

export default Diseases